export default "__VITE_ASSET__6b9c57a5__"